import React from "react";

export default function Waves() {
  const d = "M0,70 q180,-38 360,0 t360,0 t360,0 t360,0 t360,0 t360,0 t360,0 t360,0 V140 H0 Z";
  return (
    <div className="ocean-waves" aria-hidden="true">
      <svg viewBox="0 0 2880 140" preserveAspectRatio="none">
        <path className="w3" d={d} style={{ fill: "hsl(var(--water))" }} transform="translate(0,18)" />
        <path className="w2" d={d} style={{ fill: "hsl(var(--water))" }} transform="translate(0,8)" />
        <path className="w1" d={d} style={{ fill: "hsl(var(--gold))" }} />
      </svg>
    </div>
  );
}
